import React from 'react';
import { PageContainer } from '@/components/Container';
import { GameCard, DailyCard, GameSection } from '@/components/Games';

const GAME_SIGNATURE_COLORS = {
  sixDegrees: '#6B2C5F',
  rosterChamp: '#D35400',
  diamondsDugouts: '#1B4F72'
};

export function GameComponentsDemo() {
  return (
    <PageContainer>
      <div className="space-y-6">
        <h1 className="font-bebas-neue text-5xl tracking-[2px] uppercase mb-8">
          Game Components Demo
        </h1>
        
        {/* Game Cards Section */}
        <GameSection title="Daily Games" viewAllLink="/games">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <GameCard
              gameId="six-degrees"
              gameName="Six Degrees"
              gameDescription="Connect players through teams"
              signatureColor={GAME_SIGNATURE_COLORS.sixDegrees}
              icon="6°"
              to="/games/six-degrees"
            >
              <div className="grid grid-cols-7 gap-3">
                {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, index) => (
                  <DailyCard
                    key={day}
                    day={day}
                    score={index < 4 ? `${6 - index} degrees` : undefined}
                    status={index === 3 ? '--' : undefined}
                    isCompleted={index < 3}
                    isLocked={index > 3}
                    stars={index < 3 ? 3 - index : index > 3 ? 1 : 0}
                    onClick={() => console.log(`Clicked ${day}`)}
                  />
                ))}
              </div>
            </GameCard>
            
            <GameCard
              gameId="roster-champ"
              gameName="Roster Champ"
              gameDescription="Build the perfect lineup"
              signatureColor={GAME_SIGNATURE_COLORS.rosterChamp}
              icon="RC"
              to="/games/roster-champ"
            >
              <div className="grid grid-cols-7 gap-3">
                {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, index) => (
                  <DailyCard
                    key={day}
                    day={day}
                    status={
                      index < 2 ? 'completed' : 
                      index === 2 ? 'available' : 
                      'locked'
                    }
                    stars={index < 2 ? 3 : 0}
                    onClick={() => console.log(`Clicked ${day}`)}
                  />
                ))}
              </div>
            </GameCard>
          </div>
        </GameSection>
        
        {/* Individual Components */}
        <GameSection title="Component Showcase">
          <div className="space-y-8">
            {/* Single Game Card */}
            <div>
              <h3 className="font-oswald text-lg font-semibold uppercase tracking-wider mb-4">
                Game Card (No Daily Grid)
              </h3>
              <div className="max-w-md">
                <GameCard
                  gameId="diamonds-dugouts"
                  gameName="Diamonds & Dugouts"
                  gameDescription="Baseball strategy game"
                  signatureColor={GAME_SIGNATURE_COLORS.diamondsDugouts}
                  icon="D&D"
                  to="/games/diamonds-dugouts"
                />
              </div>
            </div>
            
            {/* Daily Cards States */}
            <div>
              <h3 className="font-oswald text-lg font-semibold uppercase tracking-wider mb-4">
                Daily Card States
              </h3>
              <div className="flex gap-4">
                <DailyCard
                  day="Mon"
                  date="Jan 1"
                  status="completed"
                  stars={3}
                  onClick={() => console.log('Completed')}
                />
                <DailyCard
                  day="Tue"
                  date="Jan 2"
                  status="available"
                  onClick={() => console.log('Available')}
                />
                <DailyCard
                  day="Wed"
                  date="Jan 3"
                  status="locked"
                  onClick={() => console.log('Locked')}
                />
              </div>
            </div>
          </div>
        </GameSection>
      </div>
    </PageContainer>
  );
}